import {useState} from "react";
import {EyeIcon, EyeSlashIcon} from '@phosphor-icons/react';

interface inputProps {
    value: any;
    onChange: (value: any) => void;
    className?: string;
    optionalText?: string;
    placeholder?: string;
    inputType?: string;
    inputProps?: any;
    required?: boolean;
    disabled?: boolean;
    classList?: string;
    elementRef?: any;
    id?: string;
    icon?: React.ReactNode;
    hasVisibilityButton?: boolean;
    onClickOnVisibilityButton?: (visibility: boolean) => void
}

export default function Input({
    value,
    onChange,
    className = '',
    optionalText = '',
    placeholder = '',
    inputType = 'text',
    inputProps = {},
    required = false,
    disabled = false,
    classList = '',
    elementRef,
    id,
    icon,
    hasVisibilityButton = false,
    onClickOnVisibilityButton
}: inputProps) {
    const [visible, setVisible] = useState(inputType !== 'password');
    return (
        <div className={`flex flex-col relative ${className}`}>
            <input
                ref={elementRef}
                className={`${classList} text-layout-textcolor bg-input-backgroundColor w-full p-3 border border-2 border-input-borderColor rounded-lg outline-none focus:border-primary transition-all duration-100 ${
                    hasVisibilityButton || icon ? 'pr-10' : ''
                } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                type={hasVisibilityButton ? (visible ? 'text' : 'password') : inputType}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                required={required}
                placeholder={placeholder}
                disabled={disabled}
                {...inputProps}
                id={id}
            />
            {icon && <span className="absolute right-4 h-full flex items-center">{icon}</span>}
            {hasVisibilityButton && <span className="absolute right-4 h-full flex items-center" onClick={() => {setVisible(!visible); onClickOnVisibilityButton?.(!visible)}}>{visible ? <EyeIcon/> : <EyeSlashIcon/>}</span>}
            {optionalText !== '' && <p className="pt-2">{optionalText}</p>}
        </div>
    );
}
